import { throttle } from 'lodash'

export const throttled = throttle
